import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { ProvedorToast } from './components/Toast'
import './index.css'
import { roteador } from './routes'

const clienteQuery = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
})

// Chunk 404 pós-deploy (index antigo × assets novos): recarrega UMA vez
window.addEventListener('vite:preloadError', () => {
  const chave = 'licitia.reload_pos_deploy'
  if (!sessionStorage.getItem(chave)) {
    sessionStorage.setItem(chave, '1')
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={clienteQuery}>
      <ProvedorToast>
        <RouterProvider router={roteador} />
      </ProvedorToast>
    </QueryClientProvider>
  </StrictMode>,
)
